module.exports = __webpack_public_path__ + "static/media/reassign.210b83f7.svg";